<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-10-15 16:33:27
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-11-18 16:03:12
-->
<template>
  <div id="UploadIdentity">
    <IdentifyCardUpload />
    <div class="giveUp">
      <span @click="giveUp">放弃开通Ⅱ类电子账户</span>
    </div>
    <self-popup Isclose @define="giveUpReturn" v-model="ShowPopupContent"></self-popup>

  </div>
</template>
<script>
import IdentifyCardUpload from '@/components/IdentifyCardUpload.vue';

export default {
  name: 'UploadIdentity',
  data() {
    return {
      IsShowReturnPopup: false,
      ShowPopupContent: '',
    };
  },
  components: {
    IdentifyCardUpload,
  },
  methods: {
    giveUp() {
      this.ShowPopupContent = '确定放弃开通Ⅱ类电子账户？';
    },
    giveUpReturn(obj) {
      this.$router.push('/supermarket/v2/fillCardNumber');
      // eslint-disable-next-line no-unused-expressions
      obj.cb && obj.cb();
    },
  },
};
</script>
<style scoped>
#UploadIdentity {
  width: 100%;
  height: 100%;
  background: #fff;
}
.partition {
  width: 100%;
  height: 15px;
  background: #f8f8f9;
}
.giveUp {
  text-align: center;
  margin-top: 49px;
  font-size: 14px;
  color: #0079cc;
}
</style>
